import { useForm } from '@refinedev/react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  ParticipantProfile,
  UpdateParticipant,
  UpdateParticipantSchema,
} from '@aphp-ema/common/participant';
import { HttpError } from '@refinedev/core';

export const useParticipantForm = () => {
  return useForm<ParticipantProfile, HttpError, UpdateParticipant>({
    refineCoreProps: {
      resource: 'admin/participants',
    },
    resolver: zodResolver(UpdateParticipantSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });
};
